import { useTranslation } from 'react-i18next'
import { FilterField } from './filterTypes'

interface FilterFieldSelectorProps {
  filterFields: FilterField[]
  inputValue: string
  onFieldSelect: (field: FilterField) => void
  onQuickFilter?: () => void
}

export function FilterFieldSelector({
  filterFields,
  inputValue,
  onFieldSelect,
  onQuickFilter
}: FilterFieldSelectorProps) {
  const { t } = useTranslation()

  return (
    <>
      {/* Quick filter suggestion when user is typing */}
      {inputValue.trim() && onQuickFilter && (
        <button
          onClick={onQuickFilter}
          className="w-full text-left px-3 py-2 text-sm bg-primary/10 hover:bg-primary/20 transition-colors border-b border-base-300 cursor-pointer"
        >
          <span className="font-medium">{t('fileExplorer.sortFields.name')}</span>
          {' '}
          <span className="text-base-content/70">{t('fileExplorer.filters.operators.contains')}</span>
          {' '}
          <span className="font-semibold text-primary">"{inputValue.trim()}"</span>
        </button>
      )}

      {filterFields
        .filter((field) =>
          field.label.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((field) => (
          <button
            key={field.key}
            onClick={() => onFieldSelect(field)}
            className="w-full text-left px-3 py-2 text-sm hover:bg-base-200 transition-colors cursor-pointer"
            data-testid={`filter-field-${field.key}`}
          >
            {field.label}
          </button>
        ))}
    </>
  )
}
